export const content = [
  {
    mini: "Together Against COVID",
    title: "Stay Safe &amp; Nourished With Fruits &amp; Veggies Global",
    description: "A healthy body holds a sharp mind. Call us today",
    button1: "More About Us",
    button2: "Order Now!",
    image:
      "https://swall.teahub.io/photos/small/21-215495_fruits-and-vegetables-wallpaper-hd.jpg",
    id: "inner1",
  },
  {
    mini: "With Flavory Herbs and Species:",
    title: "Add Depth and Pizazz to Your Cuisine",
    description:
      "Give every meal or dressing the kick it deserves with a nice finish",
    button1: "More About Us",
    button2: "Order Now!",
    image:
      "https://swall.teahub.io/photos/small/305-3057197_market-city-fruit-vegetables.jpg",
    id: "inner2",
  },
  {
    mini: "Farm Fresh Fruits That Are:",
    title: "Juicy, Sweet and Zesty From Our Farm To Your Heart",
    description:
      "Get that crisp sweet juice from every bite of our rich fruit collection",
    button1: "More About Us",
    button2: "Order Now!",
    image:
      "https://swall.teahub.io/photos/small/305-3057306_fruits-and-vegetables.jpg",
    id: "inner3",
  },
  {
    mini: "Most Trusted Name For:",
    title: "Fresh Succulent Vegetables Full of Flavors",
    description:
      "From leafy greens to claret garden plants, we have you covered",
    button1: "More About Us",
    button2: "Order Now!",
    image:
      "https://www.teahub.io/photos/full/168-1687981_spices-wallpaper-rodrigo-fuentes-fruit-and-vegetable-hd.jpg",
    id: "inner4",
  },
];

export const connectimg = [
  {
    img: "https://fruitsandveggiesng.com/wp-content/uploads/2021/09/fv-instagram-logo.png",
  },
  {
    img: "https://fruitsandveggiesng.com/wp-content/uploads/2021/09/fv-facebook-logo.png",
  },
  {
    img: "https://fruitsandveggiesng.com/wp-content/uploads/2021/09/fv-twitter-logo.png",
  },
];
